import { useEffect, useState } from "react";
import axios from "axios";
import AppContext from "../../AppContext";

let countedThisPageLoad = false;

const getVisitCount = (data) => {
  if (typeof data === "number") {
    return data;
  }

  if (data && typeof data === "object") {
    return Number(data.visitas ?? data.visits ?? data.count ?? data.total);
  }

  return Number(data);
};

const VisitCounter = () => {
  const [visits, setVisits] = useState(null);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const loadVisits = async () => {
      const visitsUrl = `${AppContext.baseApiUrl}${AppContext.urlServiceVisitas}`;
      const incrementUrl = `${AppContext.baseApiUrl}${AppContext.urlServiceIncrementarVisitas}`;

      try {
        let count;

        if (countedThisPageLoad) {
          const response = await axios.get(visitsUrl);
          count = getVisitCount(response.data);
        } else {
          countedThisPageLoad = true;
          const response = await axios.post(incrementUrl, {});
          count = getVisitCount(response.data);

          if (!Number.isFinite(count)) {
            const countResponse = await axios.get(visitsUrl);
            count = getVisitCount(countResponse.data);
          }
        }

        if (!Number.isFinite(count)) {
          throw new Error("La respuesta del contador de visitas no tiene un total valido.");
        }

        if (isMounted) {
          setVisits(count);
          setHasError(false);
        }
      } catch (error) {
        if (isMounted) {
          setHasError(true);
        }
      }
    };

    loadVisits();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <p className="mb-0 text-body-secondary text-sm-end">
      Visitas al sitio: {hasError ? "No disponible" : visits ?? "..."}
    </p>
  );
};

export default VisitCounter;
